
<template>
  <div class="card mb-4">
    <div class="card-body">
      <form @submit.prevent="updateCustomer">
        <div class="row">
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">
              Photo de profil
            </label>
            <div class="d-flex align-items-center">
              <img
                v-if="imagepreview"
                :src="imagepreview"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <div>
                <input
                  ref="updateImgInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="logoSelected"
                />
                <button
                  type="button"
                  class="btn btn-primary me-2"
                  @click="() => updateImgInput?.click()"
                >
                  Choisir la photo
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="cancelImage"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label for="name" class="form-label">Nom complet *</label>
            <input
              id="name"
              v-model="customerData.name"
              type="text"
              class="form-control"
              placeholder="Nom complet *"
              @change="CheckName"
              required
            />
            <div
              v-if="
                customerData.store_name === customerData.name &&
                customerData.store_name &&
                customerData.name
              "
              class="invalid-feedback d-block"
            >
              Magasin et Nom complet sont les mêmes
            </div>
            <div v-else-if="errorname" class="invalid-feedback d-block">
              Nom complet est déjà existe
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="cin" class="form-label">CIN *</label>
            <input
              id="cin"
              v-model="customerData.cin"
              type="text"
              class="form-control"
              placeholder="CIN *"
              required
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="email" class="form-label">Adresse electronique *</label>
            <input
              id="email"
              v-model="customerData.email"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': erroremail }"
              placeholder="Adresse electronique *"
              @change="CheckEmail"
              required
            />
            <div
              v-if="
                customerData.email === customerData.name &&
                customerData.email &&
                customerData.name
              "
              class="invalid-feedback d-block"
            >
              Email et Nom complet sont les mêmes
            </div>
            <div v-else-if="erroremail" class="invalid-feedback d-block">
              Email éléctronique déjà existe
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="store" class="form-label">Nom du magasin *</label>
            <input
              id="store"
              v-model="customerData.store_name"
              type="text"
              class="form-control"
              placeholder="Nom du magasin *"
              @change="CheckStore"
              required
            />
            <div
              v-if="
                customerData.store_name === customerData.name &&
                customerData.store_name &&
                customerData.name
              "
              class="invalid-feedback d-block"
            >
              Magasin et Nom complet sont les mêmes
            </div>
            <div v-else-if="errorstore" class="invalid-feedback d-block">
              Magasin déjà existe
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="phone" class="form-label">Numéro de téléphone *</label>
            <input
              id="phone"
              v-model="customerData.phone"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errorphone }"
              placeholder="Numéro de téléphone *"
              @change="CheckPhone"
              required
            />
            <div v-if="errorphone" class="invalid-feedback d-block">
              Ce numéro téléphone déjà existe
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="phone_personal" class="form-label"
              >Numéro de téléphone (Personnel)</label
            >
            <input
              id="phone_personal"
              v-model="customerData.phone_personal"
              type="text"
              class="form-control"
              placeholder="Numéro de téléphone (Personnel)"
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="password" class="form-label">Mot de passe *</label>
            <input
              id="password"
              v-model="password"
              type="password"
              class="form-control"
              placeholder="Mot de passe *"
              required
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="c_password" class="form-label"
              >Confirmation de mot de passe *</label
            >
            <input
              id="c_password"
              v-model="c_password"
              type="password"
              class="form-control"
              placeholder="Confirmation de mot de passe *"
              required
            />
            <div v-if="error" class="invalid-feedback d-block">
              Mot de passe incorrecte
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <label for="city" class="form-label">Ville *</label>
            <v-select
              id="city"
              v-model="city"
              label="name"
              :options="citiesList"
              placeholder="-- Sélectionner --"
            />
          </div>
          <div class="col-12 mb-3">
            <label for="address" class="form-label">Adresse *</label>
            <textarea
              id="address"
              v-model="customerData.address"
              class="form-control"
              rows="2"
              placeholder="Adresse *"
              required
            ></textarea>
          </div>
          <div class="col-md-6 mb-3">
            <label for="website" class="form-label">Site web *</label>
            <input
              id="website"
              v-model="customerData.website"
              type="url"
              class="form-control"
              placeholder="Site web *"
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="brand" class="form-label">Marque *</label>
            <input
              id="brand"
              v-model="customerData.brand"
              type="text"
              class="form-control"
              placeholder="Marque *"
            />
          </div>
          <div class="col-md-6 mb-3">
            <label for="type" class="form-label">Type d'entreprise</label>
            <select id="type" v-model="client_type" class="form-select">
              <option :value="null">-- Sélectionner --</option>
              <option v-for="t in typeClients" :key="t.id" :value="t">
                {{ t.name }}
              </option>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="rc" class="form-label">Registre de commerce</label>
            <input
              id="rc"
              v-model="customerData.rc"
              type="text"
              class="form-control"
              placeholder="Registre de commerce"
            />
          </div>
        </div>
        <button type="submit" class="btn btn-primary" :disabled="loading">
          Enregistrer
        </button>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, onMounted, reactive, ref } from "vue";

export default defineComponent({
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { showToast } = useAppToast();
    const auth = useAuthStore();

    const typeClients = ref<any[]>([]);
    const citiesList = ref<any[]>([]);

    // State declarations using ref and reactive
    const customerData = reactive<any>({});
    const loading = ref(false);
    const city = ref<any>(null);
    const client_type = ref<any>(null);
    const c_password = ref("");
    const password = ref("");
    const error = ref(false);
    const errorname = ref(false);
    const errorstore = ref(false);
    const erroremail = ref(false);
    const errorphone = ref(false);

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        customerData.logo = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const updateCustomer = async () => {
        error.value = false;
        if (password.value !== c_password.value) {
            error.value = true;
            showToast("Les mots de passe sont incorrects", "error");
            return;
        }

        if (!city.value) {
            showToast("Veuillez sélectionner une ville", "error");
            return;
        }

        const data = new FormData();
        data.append("c_password", c_password.value);
        data.append("password", password.value);
        if (client_type.value) {
            data.append("type_client", String(client_type.value.id));
            data.append("company_type", client_type.value.name);
        }
        data.append("adresse", customerData.address || "");
        data.append("city", city.value.name);
        data.append("email", customerData.email || "");
        data.append("phone", customerData.phone || "");
        data.append("p_phone", customerData.phone_personal || "");
        data.append("cin", customerData.cin || "");
        data.append("name", customerData.name || "");
        if (customerData.logo) data.append("logo", customerData.logo);
        data.append("magasin", customerData.store_name || "");
        data.append("website", customerData.website || "");
        data.append("brand", customerData.brand || "");
        data.append("rc", customerData.rc || "");

        loading.value = true;
        try {
            const res = await api.post(`/api/auth/new_customer_add/${props.userId}`, data);
            switch (res.data) {
                case "success":
                    showToast("Les données sont bien sauvegardées", "success");
                    try {
                        const response = await api.get("/api/auth/new_customers_count");
                        localStorage.setItem("newCstmrs", response.data.newCstmrs);
                        localStorage.setItem("newLivs", response.data.newLivs);
                    } catch (e) {
                        // ignore count errors
                    }
                    // redirect
                    window.location.href = "/new-customers-list";
                    break;
                case "not match":
                    showToast("Les mots de passe sont incorrects", "error");
                    break;
                case "exist email":
                    showToast("Email électronique est déjà existe !", "error");
                    break;
                case "exist name":
                    showToast("Nom Complet est déjà existe !", "error");
                    break;
                case "exist store":
                    showToast("Magasin est déjà existe avec ce nom!", "error");
                    break;
                case "exist phone":
                case "exist p_phone":
                    showToast("Numéro Téléphone et/ou Téléphone personnel est déjà existe !", "error");
                    break;
                case "name error":
                    showToast("Le nom complet doit être différent au nom magasin et email !", "error");
                    break;
                default:
                    showToast(res.data || "Erreur inconnue", "error");
            }
        } catch (err) {
            showToast("Une erreur est survenue, veuillez réessayer", "error");
        } finally {
            loading.value = false;
        }
    };

    const getCustomer = async () => {
      loading.value = true;
      try {
        const response = await api.get(
          `/api/auth/show_new_customer/${props.userId}`
        );
        if (response && response.data) {
          Object.assign(customerData, response.data);
          imagepreview.value = response.data.logo || null;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        loading.value = false;
      }
    };

    const CheckName = async () => {
      const data = new FormData();
      data.append("name", customerData.name);
      try {
        const res = await api.post("/api/auth/CheckName", data);
        if (res.data === "exist") {
          errorname.value = true;
          showToast("Ce Nom est déjà existe", "error");
        } else if (res.data === "success") {
          errorname.value = false;
        }
      } catch (err) {
        console.error(err);
      }
    };

    const CheckEmail = async () => {
      const data = new FormData();
      data.append("email", customerData.email);
      try {
        const res = await api.post("/api/auth/CheckEmail", data);
        if (res.data === "exist") {
          erroremail.value = true;
          showToast("Email déjà existe", "error");
        } else if (res.data === "success") {
          erroremail.value = false;
        }
      } catch (err) {
        console.error(err);
      }
    };

    const CheckStore = async () => {
      const data = new FormData();
      data.append("magasin", customerData.store_name);
      try {
        const res = await api.post("/api/auth/CheckStore", data);
        if (res.data === "exist") {
          errorstore.value = true;
          showToast("Un magasin avec ce nom est déjà existe", "error");
        } else if (res.data === "success") {
          errorstore.value = false;
        }
      } catch (err) {
        console.error(err);
      }
    };

    const CheckPhone = async () => {
      const data = new FormData();
      data.append("phone", customerData.phone);
      try {
        const res = await api.post("/api/auth/CheckPhone", data);
        if (res.data === "exist") {
          errorphone.value = true;
          showToast("Ce numéro téléphone est déjà existe", "error");
        } else if (res.data === "success") {
          errorphone.value = false;
        }
      } catch (err) {
        console.error(err);
      }
    };

    onMounted(async () => {
      await Promise.all([
        getCustomer(),
        api
          .get("/api/auth/citiesList")
          .then((res) => {
            citiesList.value = res.data || [];
          })
          .catch((err) => console.error("Error fetching cities:", err)),
        api
          .get("/api/auth/typeClients")
          .then((res) => {
            typeClients.value = res.data || [];
          })
          .catch((err) => console.error("Error fetching type clients:", err)),
      ]);

      city.value =
        citiesList.value.find((c: any) => c.name === customerData.city) ||
        null;
      client_type.value =
        typeClients.value.find(
          (t: any) => t.name === customerData.company_type
        ) || null;
    });

    return {
      customerData,
      loading,
      city,
      client_type,
      c_password,
      password,
      imagepreview,
      error,
      errorname,
      errorstore,
      erroremail,
      errorphone,
      auth,
      updateCustomer,
      cancelImage,
      logoSelected,
      updateImgInput,

      CheckPhone,
      CheckStore,
      CheckEmail,
      CheckName,
      getCustomer,
      citiesList,
      typeClients,
      // Add your methods here
    };
  },
});
</script>


